jQuery( document ).ready(function($) {

  if($('.productchoicepro').length > 0) {

    var modal = document.getElementById("myProModal");
    var span = document.getElementsByClassName("promodal_close")[0];
    modal.style.display = "block";

    let currentCheckbox
    let currentCheckboxId

    // Checkbox change //
    $('.productchoicepro_checkbox').on('change', (e) => {
      currentCheckbox = $(e.target).attr('data-id')
      currentCheckboxId = $(e.target).attr('id')
      testMulti()
      changeButton()
    })

    // No multi fomule slection //
    let testMulti = function() {
      $('.productchoicepro_checkbox').each((i, e) => {
        if($(e).attr('data-id') != currentCheckbox) {
          $(e).prop("checked", false)
        }
        if($(e).attr('id') != currentCheckboxId) {
          $(e).prop("checked", false)
        }
      })
    }

    // Change button color if checkob selected //
    let changeButton = function() {
      $('.productchoicepro_button').each((i, e) => {
        let elem = $(e)
        elem.removeClass('productchoicepro_button-valid')
        elem.addClass('productchoicepro_button-disabled')
        if(elem.attr('data-id') == currentCheckbox) {
          elem.addClass('productchoicepro_button-valid')
          elem.removeClass('productchoicepro_button-disabled')
        }
      })
    }

    $('.productchoicepro_button').on('click', (button) => {
      // modal.style.display = "block";
      // let addToCart = []
      // button.preventDefault()
      // $('.productchoicepro_checkbox').each((i, e) => {
      //   if($(e).prop("checked")) {
      //     addToCart.push(e.value)
      //   }
      // })
      // $.get("/?add-to-cart=" + addToCart[0], () => {
      //   if(addToCart[1]) {
      //     $.get("/?add-to-cart=" + addToCart[1], () => {
      //       window.location.href = '/panier'
      //     })
      //   } else {
      //     window.location.href = '/panier'
      //   }
      // })
    })

    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }

    span.onclick = function() {
      modal.style.display = "none";
    }

    $('.promodal_link').on('click', (button) => {
      let addToCart = []
      button.preventDefault()
      $('.productchoicepro_checkbox').each((i, e) => {
        if($(e).prop("checked")) {
          addToCart.push(e.value)
        }
      })
      $.get("/?add-to-cart=" + addToCart[0], () => {
        if(addToCart[1]) {
          $.get("/?add-to-cart=" + addToCart[1], () => {
            window.location.href = '/panier'
          })
        } else {
          window.location.href = '/panier'
        }
      })
    })
  }
});